import initEnableAnimations from './initHelper/initEnableAnimations';
import initFixLabels from './initHelper/initFixLabels';
import initInputEffects from './initHelper/initInputEffects';
import initMenuHandling from './initHelper/initMenuHandling';
import initPasswordInput from './initHelper/initPasswordInput';
import initPopups from './initHelper/initPopups';
import initNotifications from './signalR/notifications';

import autofillEventForInput from './globalFunctions/autofillEventForInput';
import devextremeDateFormatHelper from './globalFunctions/devextremeDateFormatHelper';
import exceptionHandler from './globalFunctions/exceptionHandler';
import tokenRefresher from './globalFunctions/tokenRefresher';
import applicationInsightsLoader from './globalFunctions/applicationInsightsLoader';
import registerGlobals from './globalFunctions/registerGlobals';

/**
 * Init global functions
 */
applicationInsightsLoader();
autofillEventForInput();
devextremeDateFormatHelper();
exceptionHandler();
tokenRefresher();
registerGlobals();

/**
 * Init helper
 */
$(document).ready(function () {
    initEnableAnimations();
    initFixLabels();
    initInputEffects();
    initMenuHandling();
    initPasswordInput();
    initPopups();
    initNotifications();
});
